<!-- data-nosnippet keeps the Google Maps UI text out of Google's search snippet.
     display:contents means this wrapper adds no layout box, so the map sizing is unchanged. -->
<div data-nosnippet style="display: contents">
<google-map
  class="map"
  [options]="mapOptions"
  [center]="mapCenter"
  (mapClick)="closeInfoWindow()"
  height="100%"
  width="100%"
  (mapInitialized)="onMapReady()"
>
  <!-- Story marker list -->
  <map-marker-clusterer [renderer]="customClusterRenderer">
    @for (marker of markerList; track marker) {
      <map-marker
        #markerRef="mapMarker"
        [position]="marker.position"
        [options]="marker.options"
        (mapMouseover)="openInfoWindow(markerRef, marker)"
        (mapClick)="openInfoWindow(markerRef, marker)"
      ></map-marker>
    }
  </map-marker-clusterer>

  <!-- User marker -->
  @if (userLocation && userLocationMarker) {
    <map-marker [position]="userLocation" [options]="userLocationMarker"></map-marker>
  }

  <map-info-window>
    <div style="padding:8px;max-width:260px">
      @if (infoWindowStory.collectionNumber) {
        <b style="color:#333;font-weight:600;position:absolute;top:18px;">
          #{{ infoWindowStory.collectionNumber }}
        </b>
      }
      @if (infoWindowStory.headerImage.thumbnailUrl) {
        <img
          [src]="infoWindowStory.headerImage.thumbnailUrl"
          [alt]="infoWindowStory.title"
          style="width:100%;height:96px;object-fit:cover;border-radius:4px;margin-bottom:8px"
        />
      }
      <h3 style="font-weight:600;font-size:14px;margin:0 0 4px;color:#333">{{ infoWindowStory.title }}</h3>
      <div class="d-flex flex-wrap gap-1">
        @for (theme of infoWindowStory.themeList; track theme.id) {
          <span style="font-size:10px;background:#fce7f3;color:#be185d;padding:2px 8px;border-radius:12px">
          {{ theme.name }}
        </span>
        }
      </div>
      @if (infoWindowStory.shortDescription) {
        <p style="font-size:12px;color:#555;">
          {{ infoWindowStory.shortDescription.length > 120 ? infoWindowStory.shortDescription.slice(0, 120) + '…' : infoWindowStory.shortDescription }}
        </p>
      }
      <div
        class="w-100 d-flex flex-wrap gap-2 justify-content-end mt-1"
        [ngClass]="{'flex-column': responsiveService.isMobileScreen$ | async}"
      >
        @if (platform.ANDROID || platform.IOS) {
          <button
            (click)="openNavigationOptions()"
            matButton="outlined"
          >
            Route
          </button>
        }
        <button
          [routerLink]="'/story/' + (infoWindowStory.url || infoWindowStory.id)"
          matButton="outlined"
        >
          @if (infoWindowStory.isProject) {
            Project bekijken
          } @else {
            Verhaal bekijken
          }
        </button>
      </div>
    </div>
  </map-info-window>
</google-map>
</div>
